import { type AxiosInstance } from "axios";

export interface Client {
  readonly http: AxiosInstance;

  download(config: {
    url: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    params?: { [key: string]: any };
  }): Promise<void>;
}

export default class Resource {
  protected get http() {
    return this.client.http;
  }

  constructor(protected client: Client) {}
}
